import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const PrefferedVendor = ({ id }) => {
  const [vendors, setVendors] = useState([]);
  const [vendorDetails, setVendorDetails] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Fetch vendors based on displayedInID
  const fetchData = async () => {
    try {
      const response = await corefetch(
        `PreferedVendors/GetVendorsDetailsByDisplayedInID?displayedInID=${id}`
      );
      if (response && response.length > 0) {
        const mappedServices = response.map((vendor) => ({
          ...vendor,
          image: `${ImageURL}${vendor.imagePath}`,
        }));
        setVendors(mappedServices);
      } else {
        setVendors([]);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
      setVendors([]);
    }
  };

  // Fetch approved vendor details by vendor ID
  const fetchVendorDetails = async (vendorId) => {
    try {
      const response = await corefetch(
        `Vendor/GetApprovedVendorDetails?vendorId=${vendorId}`
      );
      if (response && response.length > 0) {
        setVendorDetails(response);
      } else {
        setVendorDetails([]);
      }
    } catch (error) {
      console.error("Error fetching vendor details:", error);
      setVendorDetails([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  useEffect(() => {
    if (vendors?.length) {
      const $carousel = $(".rooms1-carousel");

      $carousel.owlCarousel({
        loop: true,
        margin: 30,
        autoHeight: false,
        autoplay: true,
        autoplayTimeout: 3000,
        dots: false,
        nav: true,
        navText: [
          '<i class="ti-angle-left" aria-hidden="true"></i>',
          '<i class="ti-angle-right" aria-hidden="true"></i>',
        ],
        responsiveClass: true,
        responsive: {
          0: { items: 1 },
          600: { items: 1 },
          1000: { items: 1 },
        },
      });

      // Add delegated event listener to handle clicks on cloned elements
      $carousel.on("click", ".vendor-clickable", function () {
        const vendorId = $(this).data("id");
        if (vendorId) {
          handleVendorClick(vendorId);
        }
      });

      // Cleanup on unmount
      return () => {
        $carousel.trigger("destroy.owl.carousel");
        $carousel.off("click", ".vendor-clickable");
      };
    }
  }, [vendors]);

  const handleVendorClick = (vendorId) => {
    const vendor = vendors.find((v) => v.vendorServicesID === vendorId);
    if (vendor) {
      setSelectedVendor(vendor);
      fetchVendorDetails(vendorId);
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setSelectedVendor(null);
    setVendorDetails([]);
    setIsModalOpen(false);
  };

  if (!vendors || vendors.length === 0) {
    return null;
  }

  return (
    <>
      <section className="rooms1 section-padding">
        <div className="container">
          <div className="row mb-30">
            <div className="col-md-3">
              <div className="sub-title border-bot-light">Discover</div>
            </div>
            <div className="col-md-9">
              <div className="section-title">Preferred Vendors</div>
            </div>
          </div>

          <div className="rooms1-carousel owl-theme owl-carousel">
            {vendors.map((vendor, index) => (
              <div key={index} className="rooms1-single">
                <div className="rooms1-img">
                  <img
                    src={vendor.image}
                    alt={vendor.serviceType}
                    data-id={vendor.vendorServicesID}
                    className="vendor-clickable"
                    style={{
                      cursor: "pointer",
                      objectFit: "cover",
                      objectPosition: "top",
                    }}
                  />
                </div>
                <div className="rooms1-content">
                  <div className="row">
                    <div className="col-md-12" style={{ textAlign: "center" }}>
                      <div className="rooms1-title">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleVendorClick(vendor.vendorServicesID);
                          }}
                        >
                          {vendor.serviceType}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {isModalOpen && selectedVendor && (
        <div id="dynamicModal" className="popup">
          <div
            className="modal-content"
            style={{
              maxHeight: "80vh",
              overflowY: "auto",
              padding: "20px",
              borderRadius: "8px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-header">{selectedVendor.serviceType}</div>
            {vendorDetails.length > 0 && (
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginTop: "20px",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ padding: "10px", textAlign: "left" }}>
                      Vendor Name
                    </th>
                    <th style={{ padding: "10px", textAlign: "left" }}>
                      Contact No
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {vendorDetails.map((detail, idx) => (
                    <tr key={idx}>
                      <td style={{ padding: "10px", textAlign: "left" }}>
                        {detail.vendorName}
                      </td>
                      <td style={{ padding: "10px", textAlign: "left" }}>
                        {detail.phoneNumber}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <div className="additional-text" style={{ marginTop: "20px" }}>
              {selectedVendor.description}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PrefferedVendor;
